<template>
    <div v-for="item, itemIndex in itemArray">
        <div class="mt-3">
            <div v-if="!item.editing" class="d-flex align-items-center">
                <div class="justify text-break">
                    {{ item.data }}
                </div>
                <div class="dropstart ms-3">
                    <button @click="$emit('resetEdit')" type="button" class="btn btn-outline-secondary" data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="fa-solid fa-ellipsis"></i>
                    </button>
                    <ul class="dropdown-menu">
                        <li v-if="item.fileUrl">
                            <a style="color: black;" :href="item.fileUrl" target="_blank"><div class="view mb-1"><i class="fa-solid fa-eye ms-3"></i>&nbsp; &nbsp;View</div></a>
                        </li>
                        <li @click="editItem(item, itemIndex)">
                            <a class="dropdown-item" href="#"><div class="edit mb-1"><i class="fa fa-pencil" aria-hidden="true"></i>&nbsp; &nbsp;Edit</div></a>
                        </li>
                        <li @click="deleteItem(itemIndex)">
                            <a class="dropdown-item" href="#"><div class="delete"><i class="fa-solid fa-trash-can"></i>&nbsp; &nbsp;Delete</div></a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="card p-3" v-if="item.editing">
                <div>
                    <label :for="type + itemIndex" class="form-label me-3 align-self-center" style="font-size: 16px !important;">Details:</label>
                    <textarea rows="4" v-model="itemData" type="text" class="form-control text-area" :id="type + itemIndex" style="border: 2px solid; border-style: inset;"></textarea>
                </div>
                <div class="mt-3 d-flex" v-if="type == 'universityAdmins' || type == 'committeeMemberships' || type == 'otherServices' || type == 'communityServices' || type == 'pgTeachings' || type == 'ugTeachings'">
                    <label for="sessionNum" class="form-label me-3 align-self-center" style="font-size: 16px !important;">Number of sessions/years:</label>
                    <span>
                        <input style="width: 90px" v-model="item.sessionNum" type="number"
                            class="form-control" id="sessionNum">
                    </span>
                </div>
                <br>
                <div v-if="type != 'pgTeachings' && type != 'ugTeachings' && type != 'professionalExperiences' && type !='pgSupervisions' && type != 'ugSupervisions' && type != 'communityServices' && type != 'awards'">
                    <label for="itemUrl" class="form-label" style="font-size: 16px !important;">Google Drive Link:</label>
                    <input v-model="itemUrl" type="text" class="form-control" id="itemUrl">
                    <br>
                </div>
                <div>
                    <button @click="saveItem(item, itemIndex)" class="btn btn-success mt-2">Update</button>
                    <button @click="cancelEdit(item)" class="btn btn-danger mt-2 ms-3">Cancel</button>
                </div>
            </div>
            <hr>
        </div>
    </div>
    <div v-if="array.length > 5" style="margin-bottom: -20px; font-size: small;">
        <div class="text-center" style="margin-bottom: -20px;"><b>{{ initialPageNum }}</b> to <b>{{ finalPageNum }}</b> of <b>{{array.length}}</b> items</div>
        <div class="d-flex justify-content-center">
            <nav aria-label="Page navigation example">
                <ul class="pagination">
                    <li class="page-item" @click="currentpage > 1 ? setData(currentpage - 1, 'prev') : ''">
                        <a class="page-link" aria-label="Previous">
                            <span aria-hidden="true">&laquo;</span>
                        </a>
                    </li>
                    <li class="page-item" @click="setData(1)"><a class="page-link">1</a></li>
                    <li class="page-item" @click="setData(2)"><a class="page-link">2</a></li>
                    <li class="page-item" v-if="array.length > 10" v-for="n in Math.ceil((array.length-10)/5)">
                        <a class="page-link" @click="setData(n+2)">{{ n + 2 }}</a>
                    </li>
                    <li class="page-item" @click="(currentpage < Math.ceil(array.length/5)) ? setData(currentpage + 1, 'next') : ''">
                        <a class="page-link" aria-label="Next">
                            <span aria-hidden="true">&raquo;</span>
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>
  
<script>
import DataService from '../services/dataservice';

export default {
    name: 'ViewEditDelete',
    props: ['array', 'type'],
    emits: ['candidate', 'toggleLoader', 'resetEdit'],
    data() {
        return {
            upload: false,
            itemData: '',
            itemArray: [],
            itemUrl: '',
            currentpage: 1,
            initialPageNum: 1,
            finalPageNum: 5
        }
    },
    mounted(){
        this.setData(1)
    },
    methods: {
        setData(pageNum, prevNext){
            this.itemArray = this.array.slice((5 * (pageNum - 1)), 5 * pageNum)
            this.currentpage = pageNum
            this.finalPageNum = this.currentpage * 5
            
            if (!prevNext) {
                this.initialPageNum = pageNum + (4 * (pageNum - 1))
            }
            if (prevNext == 'next') {
                this.initialPageNum += 5
            }
            if (prevNext == 'prev') {
                this.initialPageNum -= 5
            }
            if (this.currentpage == 1){
                this.initialPageNum = 1
            }
            if (this.finalPageNum > this.array.length) {
                this.finalPageNum = this.array.length
            }
        },
        editItem(item, itemIndex){
            this.$emit('toggleLoader');

            this.array.forEach(element => {
                element.editing = false
            });

            item.editing = true;

            setTimeout(() => {
                document.getElementById(this.type + itemIndex).focus()
            }, 500);
            
            //set data (details of item) in case user empties details textarea
            this.itemData = item.data;
            this.itemUrl = item.fileUrl

            this.$emit('toggleLoader');
        },
        cancelEdit(item) {
            item.editing = false
        },
        async saveItem(item, itemIndex){
            this.$emit('toggleLoader');

            if (!item.data) {
                alert('Details should not be empty');
            }
            
            //set data (details of item) back to original value
            item.data = this.itemData
            item.fileUrl = !/^https?:\/\//i.test(this.itemUrl) ? this.itemUrl ? "https://" + this.itemUrl : '' : this.itemUrl
            item.sessionNum = item.sessionNum ? item.sessionNum : 1

            item.editing = false;

            this.$emit('toggleLoader');
        },
        repopulate(item) {
            this.itemArray.splice(this.itemArray.indexOf(item), 1)
            this.array.splice(this.array.indexOf(item), 1)
            this.setData(this.currentpage)

            if (this.itemArray.length == 0) {
                this.setData((this.currentpage - 1) > 0 ? this.currentpage - 1 : 0)
            }
        },
        async deleteItem(index) {
            this.$emit('toggleLoader');

            var item = this.itemArray[index];

            if (item.fileUrl) {
                var fileDetails = {
                    fileName: item.fileName ? item.fileName : '',
                    fileType: this.type,
                    fileUrl: item.fileUrl ? item.fileUrl : '',
                    fileId: item.fileId,
                    _id: item._id
                }
                
                const candidate = await DataService.deleteFile(fileDetails);

                if (candidate){
                    this.repopulate(item)
                }
            }

            if (!item.fileUrl) {
                this.repopulate(item)
            }

            this.$emit('toggleLoader');
        }
    }
};
</script>